import service from '@/store/services/fms/dp_amount-service';

const state = {
  list: {},
  dp_amount: {},
  meta: {}
};

const mutations = {
  SET_LIST: (state, list) => {
    state.list = list;
  },
  SET_RESOURCE: (state, dp_amount) => {
    state.dp_amount = dp_amount;
  },
  SET_META: (state, meta) => {
    state.meta = meta;
  }
};

const actions = {
  list({commit, dispatch}, params) {
    return service.list(params)
      .then(({list, meta}) => {
        commit('SET_LIST', list);
        commit('SET_META', meta);
      });
  },

  get({commit, dispatch}, params) {
    return service.get(params)
      .then((dp_amount) => { commit('SET_RESOURCE', dp_amount); });
  },

  add({commit, dispatch}, params) {
    return service.add(params)
      .then((dp_amount) => { commit('SET_RESOURCE', dp_amount); });
  },

  update({commit, dispatch}, params) {
    return service.update(params)
      .then((dp_amount) => { commit('SET_RESOURCE', dp_amount); });
  },

  destroy({commit, dispatch}, params) {
    return service.destroy(params);
  },

  last_no({commit, dispatch}, params) {
    return service.last_no(params)
      .then((dp_amount) => { commit('SET_RESOURCE', dp_amount); });
  }
};

const getters = {
  list: state => state.list,
  listTotal: state => state.meta.page.total,
  dp_amount: state => state.dp_amount,
};
 
const dp_amount = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};

export default dp_amount;
